import React from "react";
import PropTypes from "prop-types";
import { Field, ErrorMessage } from "formik";
import InputError from "../styledElements/inputError";
import FormLabel from "../styledElements/label";
import StyledSelect from "../styledElements/StyledSelectSimple";

const FormikSelect = ({
    type,
    name,
    label,
    disabled,
    labelWidth,
    labelAlign,
    showError,
    onChange = () => {},
    onBlur = () => {},
    ...rest
}) => {
    return (
        <React.Fragment>
            <Field name={name}>
                {({ field, form: { touched, errors, setFieldValue } }) => {
                    const error = !!touched[field.name] && errors[field.name];
                    return (
                        <React.Fragment>
                            {label && (
                                <FormLabel
                                    align={labelAlign}
                                    width={labelWidth}
                                    name={name}
                                    {...rest}
                                >
                                    {label}
                                </FormLabel>
                            )}
                            <StyledSelect
                                {...rest}
                                name={name}
                                id={name}
                                labelWidth={labelWidth}
                                onChange={(e) => {
                                    onChange(e);
                                    setFieldValue(name, e.target.value);
                                }}
                                onBlur={(e) => {
                                    field.onBlur();
                                    onBlur(name, field.value);
                                }}
                                error={error}
                                disabled={disabled}
                            />
                        </React.Fragment>
                    );
                }}
            </Field>
            {showError && (
                <ErrorMessage name={name}>
                    {(msg) => <InputError error={msg} />}
                </ErrorMessage>
            )}
        </React.Fragment>
    );
};

FormikSelect.displayName = "FormikSelect";

FormikSelect.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    disabled: PropTypes.bool,
    height: PropTypes.number,
    labelWidth: PropTypes.number,
    labelAlign: PropTypes.string,
};

FormikSelect.defaultProps = {
    size: "default",
    type: "text",
    disabled: false,
    showError: true,
};

export default FormikSelect;
